import { connect, ConnectedProps } from "react-redux";
import {
  updateUserPassenger,
  setUserSelectedPassengerIds,
  setUserSelectedLapInfantIds,
  deleteUserPassenger,
  fetchUserPassengers,
  validatePassengers,
  setInfantOnlyError,
  setQuote,
  fetchCorpUserPassengers,
} from "../../actions/actions";
import {
  getUserPassengerCallState,
  getPriceQuoteErrors,
  getInfantOnlyError,
  getPriceQuoteWithUpdatedAncillary,
  getPassengersValidCallState,
  getCorporateInfo,
} from "../../reducer";
import { IStoreState } from "../../../../reducers/types";
import { FlightBookPassengerSelection } from "./component";

const mapStateToProps = (state: IStoreState) => {
  return {
    userPassengerCallState: getUserPassengerCallState(state),
    priceQuoteErrors: getPriceQuoteErrors(state),
    infantOnlyError: getInfantOnlyError(state),
    priceQuote: getPriceQuoteWithUpdatedAncillary(state),
    passengerValidationCallState: getPassengersValidCallState(state),
    userRoles: getCorporateInfo(state)?.role,
  };
};

const mapDispatchToProps = {
  updateUserPassenger,
  setUserSelectedPassengerIds,
  setUserSelectedLapInfantIds,
  deleteUserPassenger,
  fetchUserPassengers,
  validatePassengers,
  setInfantOnlyError,
  setQuote,
  fetchCorpUserPassengers,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type FlightBookPassengerSelectionConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedFlightBookPassengerSelection = connector(
  FlightBookPassengerSelection
);
